import { render } from "./Purchase.vue?vue&type=template&id=0119b8f3&scoped=true"
import script from "./Purchase.vue?vue&type=script&lang=js"
export * from "./Purchase.vue?vue&type=script&lang=js"

import "./Purchase.vue?vue&type=style&index=0&id=0119b8f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0119b8f3"]])

export default __exports__